import { TCreateRequestOptions } from '@fe-toolkit/axios-api-toolkit'

import { TApiRuntimeConfig } from './utils/createApiWithConfig'
import * as slices from './slices'

const createApiWithConfig = (config: TApiRuntimeConfig, options?: TCreateRequestOptions) => {
  const publicApi = slices.publicApi(
    {
      baseURL: config.PUBLIC_API_URL,
    },
    options,
  )

  return { publicApi }
}

export default createApiWithConfig
export { slices }
